import { Link } from 'react-router-dom';

const NoAccess = () => {

    return (

        <div
            style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                fontFamily: 'Arial'
            }}
        >

            <h1>No Access Permission</h1>

            <p>
                You are not authorized to access this dashboard.
            </p>

            <Link to="/login">

                <button
                    style={{
                        marginTop: '20px',
                        padding: '12px 20px',
                        border: 'none',
                        borderRadius: '10px',
                        backgroundColor: '#2563eb',
                        color: 'white',
                        cursor: 'pointer'
                    }}
                >

                    Back To Login

                </button>

            </Link>

        </div>

    );
}

export default NoAccess;